var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_cheader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.329,29V3h3.192v9.329a7.132,7.132,0,0,1,5.64-2.589,7.605,7.605,0,0,1,3.636.825,4.842,4.842,0,0,1,2.208,2.279,10.506,10.506,0,0,1,.665,4.221V29H20.478V17.064a4.932,4.932,0,0,0-1.038-3.485,3.858,3.858,0,0,0-2.935-1.091,5.176,5.176,0,0,0-2.669.736,4.157,4.157,0,0,0-1.782,2,9.164,9.164,0,0,0-.532,3.476V29Z",
    style: {
      fill: "#005f91"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCHeader);
export default __webpack_public_path__ + "static/media/c-header.c42893da7d5dfb9b09454b72b774ee35.svg";
export { ForwardRef as ReactComponent };